import './styles.scss';
import { useState, useEffect } from "react";
import {  useParams } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { fetchCompanySubscription } from "../../../../../Redux/Slices/companyManagementSlice";


function Subscriptions() {

    const {id} = useParams()
    const dispatch = useDispatch()
    const [subscriptions, setSubscriptions] = useState([]);

    useEffect(()=>{
      dispatch(
        fetchCompanySubscription({
            data:{id},
            callBack: (value)=>{
                console.log(value);
                setSubscriptions(value?.data)         
            }
        })
      )
    },[])

    return (
        <div className="subscriptionsContainer">
            <div className="subscriptionsContent">
                <h2 className="subscriptionsHeader">Subscriptions</h2>
                {subscriptions.map((subscription, index) => (
                    <div className="subscriptionDetails" key={index}>
                        <div className="subscriptionTitle">
                            <strong>{`${subscription.no_of_credit} Credits`}</strong>
                        </div>
                        <div className="subscriptionInfo">
                            <p>Added On
                            <span>: {subscription.no_of_credit > 0
                                ? new Date(subscription?.updatedAt).toLocaleDateString('en-GB') || "-"
                                : " -"}
                            </span>
                            </p>
                            <p>Due Date<span>&nbsp;&nbsp;: {subscription?.valid_date ? new Date(subscription?.valid_date).toLocaleDateString('en-GB') : "-"}</span></p>
                            {/* <p>Notes<span>: </span></p> */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Subscriptions;
